import { cloneElement, type JSX, useState } from 'react'
import { Edit } from '@mui/icons-material'
import { Box, Divider, Grid, IconButton, Typography } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

const Section = ({
  component,
  title,
  titleComponent,
  actionButton,
  showEdit = true,
}: {
  component: JSX.Element
  title?: string
  titleComponent?: JSX.Element
  actionButton?: JSX.Element
  showEdit?: boolean
}) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles

  const [isEditing, setIsEditing] = useState<boolean>(false)
  const content = showEdit ? cloneElement(component, { isEditing, setIsEditing }) : component

  return (
    <Box sx={classes.section} data-cy={title}>
      {title && (
        <Grid container={true} sx={[sharedClasses.centerContentVertical, { justifyContent: 'space-between', paddingBottom: 1.5 }]}>
          <Typography variant="subtitle1">{title}</Typography>
          {showEdit && !isEditing && (
            <IconButton color="primary" onClick={() => setIsEditing(true)} aria-label={`Edit ${title}`}>
              <Edit />
            </IconButton>
          )}
          {actionButton}
        </Grid>
      )}
      {titleComponent ? <Box sx={classes.titleComponentContainer}>{titleComponent}</Box> : null}
      <Divider sx={classes.sectionDivider} />
      {content}
    </Box>
  )
}

export default Section
